import { render, staticRenderFns } from "./Avatars.html?vue&type=template&id=7dee31a9&scoped=true&"
import script from "./Avatars.js?vue&type=script&lang=js&"
export * from "./Avatars.js?vue&type=script&lang=js&"
import style0 from "./Avatars.scss?vue&type=style&index=0&id=7dee31a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dee31a9",
  null
  
)

export default component.exports